"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
const TYPES = Object.freeze({
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
    BOTH: 'both',
});
const SIZES = Object.freeze({
    SIZE_2: 'size2',
    SIZE_4: 'size4',
    SIZE_6: 'size6',
    SIZE_8: 'size8',
    SIZE_10: 'size10',
    SIZE_12: 'size12',
    SIZE_14: 'size14',
    SIZE_16: 'size16',
    SIZE_18: 'size18',
    SIZE_20: 'size20',
    SIZE_24: 'size24',
    SIZE_28: 'size28',
    SIZE_32: 'size32',
    SIZE_36: 'size36',
    SIZE_40: 'size40',
    SIZE_48: 'size48',
    SIZE_64: 'size64',
    SIZE_96: 'size96',
    SIZE_128: 'size128',
    SIZE_144: 'size144',
    SIZE_160: 'size160',
});
const Spacing = ({ type, size, children, stretch }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('spacing', type, size, { half: !children }, { full: stretch }) }, children));
exports.Spacing = Spacing;
exports.Spacing.defaultProps = {
    stretch: false,
    type: TYPES.VERTICAL,
    children: null,
};
exports.Spacing.SIZES = SIZES;
exports.Spacing.TYPES = TYPES;
